var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenieClass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 146,
    height: 22,
    viewBox: "0 0 146 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_389",
    "data-name": "Rectangle 389",
    width: 111.966,
    height: 15.636,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-GenieClass"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GenieClass",
    clipPath: "url(#clip-GenieClass)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178698",
    "data-name": "Group 178698",
    transform: "translate(-3179 388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799",
    transform: "translate(3213 -385)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M143.274.474a7.579,7.579,0,0,1,5.351,1.967L147.6,3.979a6.716,6.716,0,0,0-4.247-1.627,5.352,5.352,0,0,0-5.471,5.6,5.527,5.527,0,0,0,5.436,5.846,6.663,6.663,0,0,0,4.556-1.9l1.1,1.487a7.9,7.9,0,0,1-5.727,2.307,7.411,7.411,0,0,1-7.491-7.733A7.35,7.35,0,0,1,143.275.474Z",
    transform: "translate(-74.336 -0.259)",
    fill: "#ea9a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M171.208,1.12l2.023.01-.057,11.492c-.006,1.272.493,1.5,1.119,1.507a3.106,3.106,0,0,0,.355-.019l-.009,1.794a5.664,5.664,0,0,1-.668.038c-1.147-.005-2.835-.327-2.822-2.976l.059-11.847Z",
    transform: "translate(-93.72 -0.613)",
    fill: "#ea9a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M189.285,14.119l.459,0v-.188a2.05,2.05,0,0,0-2.3-2.327,5.35,5.35,0,0,0-2.946,1.008l-.827-1.485A6.616,6.616,0,0,1,187.617,9.9c2.67.013,4.164,1.481,4.151,4.151l-.033,6.674-1.877-.009.005-1a7.827,7.827,0,0,1,.046-.834h-.042a3.651,3.651,0,0,1-3.389,2.068,3.3,3.3,0,0,1-3.572-3.23c.018-3.483,4.607-3.606,6.38-3.6Zm-2.362,5.2c1.711.009,2.824-1.78,2.832-3.344l0-.334-.522,0c-1.522-.007-4.277.083-4.286,1.981A1.769,1.769,0,0,0,186.923,19.322Z",
    transform: "translate(-100.158 -5.42)",
    fill: "#ea9a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M209.367,18.075a4.529,4.529,0,0,0,3.018,1.246c.876,0,1.754-.451,1.759-1.305.01-1.94-5.415-1.57-5.4-5.012.01-1.919,1.725-2.994,3.832-2.985a4.744,4.744,0,0,1,3.394,1.185l-.821,1.519a3.859,3.859,0,0,0-2.6-.951c-.876,0-1.733.366-1.738,1.284-.009,1.9,5.416,1.508,5.4,4.971-.009,1.752-1.517,3.058-3.832,3.047a5.676,5.676,0,0,1-4-1.564l.988-1.434Z",
    transform: "translate(-114.107 -5.486)",
    fill: "#ea9a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M231.173,18.184a4.529,4.529,0,0,0,3.018,1.246c.876,0,1.754-.451,1.759-1.305.01-1.94-5.415-1.57-5.4-5.012.009-1.919,1.725-2.994,3.832-2.985a4.744,4.744,0,0,1,3.394,1.185l-.821,1.519a3.859,3.859,0,0,0-2.6-.951c-.876,0-1.733.366-1.738,1.284-.01,1.9,5.416,1.508,5.4,4.971-.009,1.752-1.517,3.058-3.832,3.047a5.675,5.675,0,0,1-4-1.564l.987-1.434Z",
    transform: "translate(-126.048 -5.546)",
    fill: "#ea9a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M43.431,9.286c3.038.015,4.66,2.235,4.646,5.025,0,.31-.067,1.012-.067,1.012l-7.276-.036a3,3,0,0,0,3.149,2.806,5.206,5.206,0,0,0,3.044-1.142l1,1.887a6.586,6.586,0,0,1-4.244,1.488,5.4,5.4,0,0,1-5.636-5.547,5.21,5.21,0,0,1,5.381-5.492Zm2,4.227a2.035,2.035,0,0,0-2.077-2.2,2.454,2.454,0,0,0-2.532,2.178l4.609.023Z",
    transform: "translate(-20.836 -5.085)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M66.576,9.655l2.522.013-.006,1.219a6.508,6.508,0,0,1-.045.723h.042A4.087,4.087,0,0,1,72.84,9.438c2.336.011,3.653,1.238,3.639,4.028l-.033,6.78-2.6-.013.031-6.242c.006-1.282-.32-2.151-1.664-2.158a2.91,2.91,0,0,0-2.842,2.135,4.438,4.438,0,0,0-.193,1.4l-.024,4.837L66.524,20.2Z",
    transform: "translate(-36.428 -5.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M97.042.4h.3a1.289,1.289,0,1,1-.013,2.578l-.3,0A1.289,1.289,0,1,1,97.042.4m-1.185,4.37,2.625.013-.052,10.542L95.8,15.315Z",
    transform: "translate(-52.431 -0.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M113.182,9.633c3.038.015,4.66,2.235,4.646,5.025,0,.31-.067,1.012-.067,1.012l-7.276-.036a3,3,0,0,0,3.149,2.806,5.206,5.206,0,0,0,3.044-1.142l1,1.887a6.588,6.588,0,0,1-4.244,1.488,5.4,5.4,0,0,1-5.636-5.547A5.21,5.21,0,0,1,113.182,9.633Zm2,4.227a2.036,2.036,0,0,0-2.077-2.2,2.455,2.455,0,0,0-2.533,2.178l4.61.023Z",
    transform: "translate(-59.031 -5.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M9.816,8.353,7.922,10.228a16.349,16.349,0,0,1,2.935.194,5.945,5.945,0,0,1-2.338,2,3.575,3.575,0,0,1-2.641-.057A4.823,4.823,0,0,1,2.81,8.373,6.963,6.963,0,0,1,2.737,7.35a5.774,5.774,0,0,1,.172-1.3l0-.01h0a4.588,4.588,0,0,1,4.416-3.6,6.672,6.672,0,0,1,4.82,1.815l1.665-1.649A8.071,8.071,0,0,0,7.355,0H7.34A7.319,7.319,0,0,0,.15,6.021l0,.011A7.8,7.8,0,0,0,0,7.42,9.015,9.015,0,0,0,.052,8.426h0a7.153,7.153,0,0,0,7.191,6.737c1.115.068,3.33-.416,5.287-2.947a16.079,16.079,0,0,1,.164,2.87v.036l1.9-1.886.024-4.857-4.8-.024Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "GB_GenieClass_Icon",
    transform: "translate(3179 -388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1356",
    "data-name": "Group 1356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M23.526,21.92H2.434A2.437,2.437,0,0,1,0,19.486V6.335A2.437,2.437,0,0,1,2.434,3.9H23.526A2.437,2.437,0,0,1,25.96,6.335V19.486A2.436,2.436,0,0,1,23.526,21.92ZM2.434,5.523a.812.812,0,0,0-.811.811V19.486a.812.812,0,0,0,.811.811H23.526a.812.812,0,0,0,.811-.811V6.335a.812.812,0,0,0-.811-.811Z",
    transform: "translate(0 -3.901)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1357",
    "data-name": "Group 1357",
    transform: "translate(7.842 16.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M23.964,39.562H15.311a.811.811,0,0,1-.811-.811c0-2.5,2.3-4.533,5.138-4.533s5.138,2.033,5.138,4.533A.811.811,0,0,1,23.964,39.562Zm-7.7-1.622h6.753a3.494,3.494,0,0,0-3.376-2.1A3.494,3.494,0,0,0,16.261,37.939Z",
    transform: "translate(-14.5 -34.218)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358",
    transform: "translate(0.811 13.148)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1178",
    "data-name": "Rectangle 1178",
    width: 24.337,
    height: 1.622,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_319",
    "data-name": "Ellipse 319",
    cx: 0.811,
    cy: 0.811,
    rx: 0.811,
    ry: 0.811,
    transform: "translate(21.705 2.632)",
    fill: "#f7941e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_320",
    "data-name": "Ellipse 320",
    cx: 0.811,
    cy: 0.811,
    rx: 0.811,
    ry: 0.811,
    transform: "translate(19.072 2.632)",
    fill: "#f7941e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    "data-name": "Group 1359",
    transform: "translate(10.231 4.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M24.258,14.9l-4.87-2.812a.314.314,0,0,0-.471.271v5.623a.314.314,0,0,0,.471.271l4.87-2.812A.313.313,0,0,0,24.258,14.9Z",
    transform: "translate(-18.917 -12.047)",
    fill: "#f7941e"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenieClass);
export default __webpack_public_path__ + "static/media/GenieClass.3d4d25e9a74d0af95ea1b231a45bf9e9.svg";
export { ForwardRef as ReactComponent };